import Vue from'vue'
import VueI18n from 'vue-i18n';
import en from '../en'
import zh from '../zh'
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'zh', // 默认语言
    fallbackLocale: 'en', // 当当前语言缺失翻译时使用的备用语言
    messages: {
        en,
        zh
    }
});
export default i18n